import * as Objdict from "objdict"
import App from "@frog/source/models/App.js"
import Random from "@frog/source/utility/Random.js"
import Geometry from "@frog/source/utility/Geometry.js"

import pixel from "@frog/source/views/utility/pixel.js"
import timer from "@frog/source/juice/utility/timer.js"
// import * as deathzone from "@frog/source/data/deathzone.js"
import sizes from "@frog/source/data/sizes.js"
import Zone from "@frog/source/models/Zone.js"
import {getImageFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"
import {getTime} from "@frog/source/juice/utility/Time.js"

const BACKGROUNDS = [
    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-0-full.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-1-full.png").default,
    require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-2-full.png").default,
]

import getTimeOfDay from "@frog/source/models/logic/getTimeOfDay.js"

let flickering = 0.5

export default function WorldTerrain(stage) {
    // return {
    //     "key": "world",
    //     "position": pixel("terrain", {"x": -0.5, "y": -1, "z": 0}),
    //     "image": require("@frog/source/assets/images/pirate-tactics/map.png").default,
    // }

    const blocks = Object.values(stage.world.blocks || []).map((block, index) => {
        // let images = block.images
        let images = [block.imageVariants[Math.min(2, getTimeOfDay(stage))]]
        // if(block.animation != undefined) {
        //     images = images.concat(getImageFromAnimation(block.animation, getTime().ms + (index * 0)))
        // }
        return images.map((image, index) => {
            if(App.game.encounter.selection.isOnCamera(block.position) != true) {
                return
            }
            if(Zone.isOutOfBounds(App.game.encounter.stage.encounters[App.game.encounter.stage.currentEncounter || 1].zone, block.position)) {
                return
            }
            const layers = {
                "background": "background-block",
                "foreground": "foreground-block",
            }
            return {
                "key": "world/blocks/" + block.position.x + "x" + block.position.y + "x" + block.position.z + "/index/" + index,
                "position": pixel(layers[block.layer] || "block", {
                    "x": block.position.x,
                    "y": block.position.y,
                    "z": block.position.z,
                }),
                "image": image,

                "anchor": {"x": "50%", "y": "100%"},

                // "width": 16, // HARDCODED
                // "height": 16, // HARDCODED
                "tint": getTint(stage, block),
                "_": [
                    // Influence(stage,  block)
                ]
            }
        })
    })

    Math.clamp = function(min = 0, max = 1, value) {
        return Math.max(min, Math.min(max, value))
    }
    const speed = 0.5
    if(getTimeOfDay(stage) >= 2) {
        flickering = Math.clamp(0, 2, flickering + Random.range(-speed, speed))
    } else {
        flickering = (Math.sin(Date.now() / 500) + 1)
    }
    const SHADOW_SCALE = 32 + flickering
    return {
        "_": [
            {
                "position": {x: -576, y: -192},
                "image": BACKGROUNDS[Math.min(2, getTimeOfDay(stage))],
                // "tint": {
                //     "color": 0x152248,
                //     // "color": "#CC0000",
                //     "intensity": 0.2,
                // },
            },
            blocks,
            {
                "position": {
                    "x": sizes.camera.position.x + (512 / 2),
                    "y": sizes.camera.position.y + (288 / 2),
                    "stack": 99999
                },
                "anchor": {
                    "x": "50%",
                    "y": "50%",
                },
                "image": require("@frog/source/assets/images/apocalypse-tactics/shadow-320-to-384.png").default,
                "width": 16 * SHADOW_SCALE,
                "height": 9 * SHADOW_SCALE,
                "opacity": 0.2 * (getTimeOfDay(stage) + 1),

                // "tint": {
                //     "color": 0x152248,
                //     // "color": "#CC0000",
                //     "intensity": 0.2,
                // },
            },
        ]
    }
}

// TODO: Can I someday do masking for the shadows instead of a mostly-black-pre-masked-image?
// Can I eventually do proper palette swapping rather than just tinting?

// const SHADOW = [
//     require("@frog/source/assets/images/apocalypse-tactics/shadow-320x160.png").default,
//     require("@frog/source/assets/images/apocalypse-tactics/shadow-352x176.png").default,
//     require("@frog/source/assets/images/apocalypse-tactics/shadow-384x192.png").default,
// ]

function getTint(stage, block) {
    // if(Zone.isOutOfBounds(stage.encounters[stage.currentEncounter || 1].zone, block.position)) {
    //     return {
    //         "color": 0x000000,
    //         "color": 0x152248,
    //         "intensity": 0.8,
    //     }
    // }
    // shadow
    // if(stage.light != undefined
    // && stage.light[block.position.x + "x" + block.position.y] == undefined) {
    //     return {
    //         "color": 0x152248,
    //         "intensity": 0.5,
    //     }
    // }
    // if(Geometry.equals2d(block.position, App.game.encounter.selection.position)) {
    //     return {
    //         "color": "#CC0000",
    //         "intensity": 0.5,
    //     }
    // }
}

import {colortween} from "@frog/source/juice/utility/Tweens.js"
import Text from "@frog/source/views/Text.view.js"

function Influence(stage, block) {
    if(Zone.isOutOfBounds(App.game.encounter.stage.encounters[App.game.encounter.stage.currentEncounter || 1].zone, block.position)) {
        return
    }
    if(App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.influenceMap != undefined) {
        const influenceMap = App.game.encounter.selection.hoveredAction.influenceMap
        const percent = Math.max(0, Math.min((influenceMap[block.position.x + "x" + block.position.y] || 0) / 200, 1))
        return [
            Text({
                "text": percent == 0 ? "-" : (percent < 1 ? percent * 100 : "X0"),
                // "font": "numbers",
            }),
            {
                "width": 16,
                "height": 16,
                "color": colortween("#FFFFFF", "#CC0000", percent, "hexstring"),
                "position": {"x": 0, "y": 0, "stack": -1},
            },
        ]
    }
}
